import React from "react";

export default function useKeyValueState(initialState) {
    const [ state, setState ] = React.useState(initialState);
    const setKey = React.useCallback(
        (key, value) => // update key, value
            setState(s => ({ ...s, [key]: value })),
        [ setState ],
    );
    return [ state, setKey ];
};



// WEBPACK FOOTER //
// ./app/lib/hex/views/components/useKeyValueState.js